// El texto del WhatsApp con el que se entrega un comprobante — RN-151.
//
// SPEC_NOTAS_DE_CREDITO_v0.1.md (RN-151) · PLAN P-Y16
//
// Puro y en un solo lugar. Hasta acá el modal elegía entre dos frases con un
// ternario (factura / recibo). Con la nota de crédito, la constancia de
// anulación del recibo y los documentos anulados son siete casos, y un mensaje
// equivocado no es un detalle: decirle «podés consultar tu factura» a alguien
// cuya factura se anuló es mandarle a cobrar algo que ya no rige.
//
// `documento` es lo que devuelve el endpoint del comprobante:
//   { tipo, numero, anulado, documento_acreditado? }

const nombrar = (tipo, numero) => {
  switch (tipo) {
    case 'RECIBO':
      return numero ? `el recibo N.º ${numero}` : 'el recibo'
    case 'NOTA_CREDITO':
      return numero ? `la nota de crédito ${numero}` : 'la nota de crédito'
    case 'RECIBO_ANULACION':
      return numero ? `la constancia de anulación N.º ${numero}` : 'la constancia de anulación'
    default:
      return numero ? `la factura ${numero}` : 'la factura'
  }
}

export function mensajeDeEntrega (documento = {}, url = '') {
  const { tipo = 'FACTURA', numero = null, anulado = false, documento_acreditado: acreditado = null } = documento

  if (tipo === 'NOTA_CREDITO') {
    const anula = acreditado ? `, que anula ${nombrar('FACTURA', acreditado)}` : ''
    return `Hola, te enviamos ${nombrar(tipo, numero)}${anula}. Podés verla y descargarla acá: ${url}`
  }
  if (tipo === 'RECIBO_ANULACION') {
    const anula = acreditado ? `, que anula ${nombrar('RECIBO', acreditado)}` : ''
    return `Hola, te enviamos ${nombrar(tipo, numero)}${anula}. Podés verla y descargarla acá: ${url}`
  }
  if (anulado) {
    const verbo = tipo === 'RECIBO' ? 'fue anulado' : 'fue anulada'
    return `Hola, te avisamos que ${nombrar(tipo, numero)} ${verbo}. Podés ver el documento acá: ${url}`
  }
  if (tipo === 'RECIBO') {
    return `Hola, acá podés ver y descargar tu recibo${numero ? ` N.º ${numero}` : ''}: ${url}`
  }
  return `Hola, podés consultar tu factura${numero ? ` ${numero}` : ''} acá: ${url}`
}
